import { useContext, useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { AuthContext } from 'state/auth';
import { routes } from 'utils/routing';

interface IProps {
  skip?: boolean;
  keepParams?: boolean;
  searchParamsOverride?: URLSearchParams;
}

export default function useAuthRedirects(
  props: IProps | undefined = { skip: false, keepParams: false }
) {
  const { loading, isAuthenticated, originLocation, setOriginLocation } = useContext(AuthContext);
  const authenticated = isAuthenticated();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (props.skip) {
      return;
    }

    if (loading) {
      return;
    }

    if (authenticated && originLocation) {
      const nextLocation = originLocation;
      setOriginLocation(null);
      navigate(nextLocation, { replace: true });
    } else if (
      !authenticated &&
      location.pathname !== routes.signIn &&
      location.pathname !== routes.signUp
    ) {
      setOriginLocation(`${location.pathname}${location.search}`);

      const searchParamsOverride = props.searchParamsOverride
        ? `?${props.searchParamsOverride.toString()}`
        : undefined;
      const searchParams = searchParamsOverride ?? location.search;
      const nextSearchParams = props.keepParams ? searchParams : '';
      const next = routes.signUp + nextSearchParams;
      navigate(next, { replace: true });
    }
  }, [
    authenticated,
    loading,
    location.pathname,
    location.search,
    originLocation,
    setOriginLocation,
    navigate,
    props.skip,
    props.keepParams,
    props.searchParamsOverride,
  ]);
}
